<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'master-port',
  components: {
    PageTable,
  },
}
</script>
